module.exports = __webpack_public_path__ + "img/404.45d28846.svg";